// extracted by mini-css-extract-plugin
export default {"numberRoot":"Number_numberRoot__upd5j","input":"Number_input__YrGu7"};